import React, { useState, useEffect } from 'react';
import { useFirestore } from '../hooks/useFirestore';

const CRMPage = () => {
  const [clients, setClients] = useState([]);
  const { getClients, updateClientStatus } = useFirestore();

  useEffect(() => {
    const fetchClients = async () => {
      const fetchedClients = await getClients();
      setClients(fetchedClients);
    };
    fetchClients();
  }, [getClients]);

  const handleStatusChange = async (clientId, newStatus) => {
    await updateClientStatus(clientId, newStatus);
    setClients(clients.map(client => 
      client.id === clientId ? { ...client, status: newStatus } : client
    ));
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">CRM - Gestión de Clientes</h1>
      <table className="w-full">
        <thead>
          <tr>
            <th className="text-left">Nombre</th>
            <th className="text-left">Email</th>
            <th className="text-left">Estado</th>
            <th className="text-left">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client) => (
            <tr key={client.id}>
              <td>{client.name}</td>
              <td>{client.email}</td>
              <td>{client.status}</td>
              <td>
                <select
                  value={client.status}
                  onChange={(e) => handleStatusChange(client.id, e.target.value)}
                  className="p-2 border rounded-md"
                >
                  <option value="lead">Lead</option>
                  <option value="prospect">Prospect</option>
                  <option value="customer">Customer</option>
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CRMPage;